import React, { Component, Fragment } from 'react';
import InventoryHeader from './InventoryHeader';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

@inject('InventoryStore')
@observer
class InventoryStockCountShiftComponents extends Component {
    render() {
        return (
            <Fragment>
                <InventoryHeader title="Stock Count" backLink="" />
                <div className="inventory-menu">
                    <h2>{moment().format('dddd - DD/MM/YYYY')}</h2>
                    <div className="btn-wrapper mm mtxl">
                        <Link
                            to={{
                                pathname: `/inventory/stock-count/components/initial`,
                                state: { itemType: 'Component' },
                            }}
                        >
                            <button className="btn btn-primary width--300px">
                                Initial Daily Check
                            </button>
                        </Link>
                    </div>
                    <div className="btn-wrapper mm">
                        <Link
                            to={{
                                pathname: `/inventory/stock-count/components/final`,
                                state: { itemType: 'Component' },
                            }}
                        >
                            <button className="btn btn-primary width--300px">
                                Final Daily Check
                            </button>
                        </Link>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default InventoryStockCountShiftComponents;
